const hasHTMLCode = (text: string): boolean => {
  const htmlRegex = /<[^>]*>/ // Regular expression to match any HTML tag
  return htmlRegex.test(text)
}

export { hasHTMLCode }
